/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import React, { useState, useEffect, useCallback, useRef } from "react";
import "./OrganizationUserList.scss";
import { Search, useNavigate, useLocation } from "react-router-dom";
import { IconButton, TablePaginationProps, Tooltip } from "@mui/material";
import { InputText } from "primereact/inputtext";
import downloadIcon from "../../../images/Download_icon.png";
import refresh from "../../../images/Refresh_icon.png";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import {
  DataGrid,
  GridPagination,
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";

import MuiPagination from "@mui/material/Pagination";
import { deleteOrganizationbyID, getOrganizationByTenantID } from "../../../store/Organisation/organisation-actions";
import updateErrorList from "../../../utils/methods/updateErrorList";
import {
  IErrorProps,
  Role,
  UserDto,
  WrapperUserPermissions,
} from "../../../models";
import Loader from "../../Loader/Loader";
import TreeTableOrganizationData from "../../../models/apiModels/TreeTableOrganizationData";
import DeleteDialog from "../../SharedComponents/DeleteDialog";
import getOrganizationKeyByOrgId from "../../../utils/methods/getOrganizationKeyByOrgId";
import SuccessDialog from "../../SharedComponents/SuccessDialog";
import getAllParentKeys from "../../../utils/methods/getAllParentKeys";
import { organizationActions } from "../../../store/Organisation/organisation-slice";
import UserPermissions from "../../../models/apiModels/UserPermissions";
import { deleteTenantUser } from "../../../store/User/user-actions";
import { getOrganizationUserByTenantID, getUserListBasedOnForgeCustomerId } from "../../../store/User/user-actions";
import OrganizationHDTOKey from "../../../models/apiModels/OrganizationHDTOKey";
import { gridColumns } from "../../SharedComponents/helperForDataGrid/gridColumns";
import BreadCrumbsComponent from "../../SharedComponents/BreadCrumbs/BreadCrumbsComponent";
import Title from "../../SharedComponents/Title/Title";
import {
  Button,
  Card,
  Chip,
  ChipRemove,
  ImportIcon,
  Input,
  RefreshIcon,
  SearchIcon,
} from "@forge/common";
import OrganizationInfoComponent from "./OrganizationInfoComponent";
import TemporaryDrawerForOrgUser from "./TemporaryDrawerForOrgUser";
import { downloadUserListExcel } from "../../../utils/methods/downloadUserListExcel";
import { serverErrorClose } from "../../SharedComponents/serverErrorClose";
import { setErrorPopupsusingErrorCode } from "../../TenantUser/setErrorPopupsusingErrorCode";
import ErrorHandlingComponent from "../../SharedComponents/ErrorHandlingComponent";
import { send } from "process";
import getOrganizationNameById from "../../../utils/methods/getOrganizationNameById";
import OrganizationDTO from "../../../models/apiModels/OrganizationDTO";
import { getNoRowsLabel } from "../../../utils/methods/getNoRowsLabel";
import { useOidcAccessToken } from "@axa-fr/react-oidc";
import GetTokenValues from "../../../utils/methods/GetTokenValues";
import getRelevantUsersBasedOnPersona from "../../../utils/methods/getRelevantUsersBasedOnPersona";
import getLoggedInUserId from "../../../utils/methods/getLoggedInUserId";
import { dataGridConfig } from "../../../utils/mui-x-data-grid/config";
import GoToPage from "../../../utils/mui-x-data-grid/GoToPage";
import { getUsernamebyId } from "../../../utils/methods/getUsernamebyId";
import { useTranslation } from '@scuf/localization';
import { localeKeyMap } from '../../../localization/keys';
import NotificationBanner from "../../SharedComponents/NotificationBanner";
import { ConfigurationVariables } from "../../../config";

const POLLING_INTERVAL = parseInt(ConfigurationVariables.POLLING_INTERVAL) || 5000;
const MAX_ATTEMPTS = 10;
const LOCATION_PATHNAME = '/organization-user-list';
const ORGANIZATION_CRUMB_ID = "Organization";

const OrganizationUserList = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const tokenValues = GetTokenValues();
  let accessTokenPayload =
    tokenValues !== undefined
      ? tokenValues.accessTokenPayload
      : {
          sub: "",
          ext: {
            customer: "",
            tenant_id: "",
          },
        };

  const tokenInfo = {
    customer: accessTokenPayload?.ext?.customer ?? "",
    tenant: accessTokenPayload?.ext?.tenant_id ?? "",
    userId: accessTokenPayload?.sub ?? "",
  };
  const tenantId = tokenInfo.tenant;
  const dispatch: AppDispatch = useDispatch();

  const treeTableOrganization: TreeTableOrganizationData[] = useSelector(
    (state: RootState) => state.organisation.treeTableOrganization
  );
  const organizationOrigionaldata: OrganizationDTO[] = useSelector(
    (state: RootState) => state.organisation.availableOrganization
  );
  const [openforDeleteUsers, setOpenforDeleteUsers] = useState(false);
  const [getAllGridData, setGetAllGridData] = useState<any>([]);

  const originalGetUserData: UserDto[] = useSelector(
    (state: RootState) => state.user.originalGetUserData
  );

  const organizationUserPageDetailsStore: {
    tenantId: string;
    UserInfo: TreeTableOrganizationData;
  } = useSelector(
    (state: RootState) => state.organisation.organizationUserPageDetails
  );
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);

  const [getUserDetails, setGetUserDetails] =
    useState<TreeTableOrganizationData>(
      organizationUserPageDetailsStore?.UserInfo
    );

  const [OrgToDelete, setOrgToDelete] = useState<any>();

  const [getUserTenantId, setGetUserTenantId] = useState<string>(
    organizationUserPageDetailsStore?.tenantId
  );

  const [userSelected, setUserSelected] = useState({
    customerId: "",
    userId: "",
  });

  const [successDialogOpenforUsers, setSuccessDialogOpenforUsers] =
    useState(false);

  const userPermissions: WrapperUserPermissions = useSelector(
    (state: RootState) => state.user.userPermissions
  );

  const hierarchicalOrganizationwKey: OrganizationHDTOKey[] = useSelector(
    (state: RootState) => state.organisation.hierarchicalOrganizationwKey
  );

  const [tenantUsersToDelete, setTenantUsersToDelete] = useState<{
    customerId: string;
    userIds: Array<string>;
  }>({
    customerId: "",
    userIds: [],
  });
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [hidebox, setHideBox] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [filteringGroup, setFilteringGroup] = useState<Role[]>([]);
  const [searchedText, setSearchedText] = useState("");

  // Add refresh key to force DataGrid re-render
  const [refreshKey, setRefreshKey] = useState(0);

  // Simple polling refs and state for user creation
  const pollingInterval = useRef<NodeJS.Timeout | null>(null);
  const pollingStarted = useRef<boolean>(false);
  const [showNotificationBanner, setShowNotificationBanner] = useState(false);
  const [newUserEmail, setNewUserEmail] = useState<string>("");

  // Refs and state for user update polling
  const [showUpdateBanner, setShowUpdateBanner] = useState(false);
  const userUpdatePollingRef = useRef<NodeJS.Timeout | null>(null);
  const userUpdateInfoRef = useRef<any>(null);
  const hasStartedPollingRef = useRef(false);
  const userUpdateAttemptsRef = useRef(0);

  ///////////////Error Handling////////////////////////
  const [isLoading, setIsLoading] = useState(false);
  const toastErrors = useRef<IErrorProps[]>([]);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);

  const [paginationModel, setPaginationModel] = useState({
    ...dataGridConfig.paginationModel,
  });

  const loggedInUserId = getLoggedInUserId();

  // Organization ID state
  const [orgId, setOrgId] = useState<string | undefined>(
    organizationUserPageDetailsStore?.UserInfo?.data?.organizationId
  );

  // Simple polling cleanup
  const stopPolling = () => {
    if (pollingInterval.current) {
      clearInterval(pollingInterval.current);
      pollingInterval.current = null;
    }
    pollingStarted.current = false;
    setShowNotificationBanner(false);
    setNewUserEmail("");
    // Remove URL parameter
    window.history.replaceState({}, "", window.location.pathname);
  };

  const onDialogForServerCloseHandler = () => {
    serverErrorClose({
      errorListGlobal,
      setOpenDialogServerError,
      setErrorListGlobal,
    });
  };

  const customLocaleText = {
    noRowsLabel: getNoRowsLabel(
      searchedText,
      filteringGroup?.length !== 0,
      false,
      t(localeKeyMap.noUsersAvailable)
    ),
  };

  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };

  // istanbul ignore next
  // on handleToastBarClose
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  // istanbul ignore next
  useEffect(() => {
    setErrorPopupsusingErrorCode({
      errorListGlobal,
      setOpenDialogNoURLError,
      setOpenToastError,
      setOpenDialogServerError,
      openDialogNoURLError,
      openToastError,
      openDialogServerError,
    });
  }, [errorListGlobal]);

  //////////////Error Handling////////////////////////

  const createUserHandler = () => {
    if (userPermissions.can_create_organisation_user) {
      navigate("/organization/user/create", {
        state: {
          forgetenantID: tenantId,
          userDetailsToEdit: {
            UserInfo: {
              organization: [getUserDetails?.data?.organizationId],
            },
          },
        },
      });
    } else {
      const error: IErrorProps = {
        errorCode: 403,
        errorMessage: t(localeKeyMap.noPrivilegesToCreateUsers),
      };
      setErrorListGlobal((prevState) => updateErrorList(error, [...prevState]));

      setOpenToastError(true);
    }
  };

  // Handle confirmation
  // istanbul ignore next
  // This is passed to Dialog
  const handleDeleteConfirmationforUsers = () => {
    setOpenforDeleteUsers(false);
    setIsLoading(true);

    dispatch(deleteTenantUser(tenantUsersToDelete))
      .unwrap()
      .then(() => {
        setUserSelected({
          userId: "",
          customerId: "",
        });

        setTenantUsersToDelete({
          customerId: "",
          userIds: [],
        });
        setSuccessDialogOpenforUsers(true);
      })
      .catch((error: any) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => setIsLoading(false));
  };

  const getOrgUserList = () => {

    if (!orgId) {
      return;
    }
    
    const sendOrgData: any = {
      tenantID: tokenInfo.tenant,
      organizationId: orgId,
    };
    if (
      userPermissions.can_read_organisation_user
    ) {
      setIsLoadingUsers(true);

      dispatch(getOrganizationUserByTenantID(sendOrgData))
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => setIsLoadingUsers(false));
    } else {
      const error: IErrorProps = {
        errorCode: 403,
        errorMessage: t(localeKeyMap.noPrivilegesToReadOrganizations),
      };
      setErrorListGlobal((prevState) => updateErrorList(error, [...prevState]));
    }
  };

  /**
   * Todownload the excel file of user list
   */
  const downloadExcel = () => {
    if (getAllGridData?.length > 0) {
      downloadUserListExcel(getAllGridData, selectedIds);
    }
  };

  const setOrgUserList = () => {
    const persona = userPermissions.user_persona;

    let dataWithIds: any = originalGetUserData?.filter((user) => {
      if (
        filteringGroup?.length === 0 &&
        filteringGroup !== undefined &&
        filteringGroup !== null
      ) {
        return true;
      }

      return user.roles?.some((role: Role) =>
        filteringGroup?.some(
          (filterRole: Role) => filterRole.roleId === role.roleId
        )
      );
    });
    dataWithIds = dataWithIds?.filter((user: any) => {
      if (searchedText === "") {
        return true;
      }
      return (
        user.firstName?.toLowerCase().includes(searchedText?.toLowerCase()) ||
        user.lastName?.toLowerCase().includes(searchedText?.toLowerCase()) ||
        user.emailId?.toLowerCase().includes(searchedText?.toLowerCase()) ||
        user.organization?.some((org: any) =>
          org.name.toLowerCase().includes(searchedText?.toLowerCase())
        ) ||
        user.roles?.some((role: Role) =>
          role.name.toLowerCase().includes(searchedText?.toLowerCase())
        )
      );
    });
    // Get only persona related users
    dataWithIds = getRelevantUsersBasedOnPersona(dataWithIds, persona);
    setGetAllGridData(dataWithIds);
    setRefreshKey((prev) => prev + 1);
  };

   // Restore organization data on page refresh and handle initial load
  useEffect(() => {
    const storedOrgData = sessionStorage.getItem('selectedOrganizationData');
    
    if (!storedOrgData) {
      return;
    }
    
    let parsedOrgData: TreeTableOrganizationData;
    try {
      parsedOrgData = JSON.parse(storedOrgData);
    } catch (e) {
      return;
    }
    setGetUserDetails(parsedOrgData);
    setOrgId(parsedOrgData.data?.organizationId);
    
    // Update breadcrumb with organization name
    setCrumbs(prev => [
      prev[0],
      { ...prev[1], label: parsedOrgData.data?.name || "" }
    ]);
    
    // Load organization tree data so parentNodeName can be calculated
    dispatch(getOrganizationByTenantID({ tenantID: tokenInfo.tenant, userPermissions }))
      .unwrap()
      .catch((error: any) => {
        const errorMsg = error?.message || t(localeKeyMap.failedToLoadOrganizationTreeData);
        const errorObj: IErrorProps = {
          errorCode: error?.status || 500,
          errorMessage: errorMsg,
        };
        setErrorListGlobal((prevState) => updateErrorList(errorObj, [...prevState]));
      });
  }, []);
  
   // Restore organization user list on page refresh
  useEffect(() => {
    // Guard: Exit if no org ID or no read permissions
    if (!orgId || !userPermissions.can_read_organisation_user) {
      return;
    }
    
    // Happy path: Fetch user list
    getOrgUserList();
  }, [orgId, userPermissions.can_read_organisation_user]);



  useEffect(() => {
    if (originalGetUserData?.length >= 0) { // Process data including empty states. for displaying empty table in case of only one org which is moved to another org
      setOrgUserList();
    }
  }, [originalGetUserData, filteringGroup, searchedText]);

  // Handle user creation banner with simple polling
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const userCreated = urlParams.get("userCreated");
    const userEmail = urlParams.get("userEmail");

    if (
      userCreated === "true" &&
      userEmail &&
      !pollingStarted.current &&
      getUserDetails?.data.organizationId &&
      userPermissions.can_read_organisation_user &&
      getUserDetails?.permissionSet?.can_read_organisation_user
    ) {
      pollingStarted.current = true;
      setShowNotificationBanner(true);
      setNewUserEmail(userEmail);

      let attempts = 0;

      const poll = () => {
        attempts++;

        const sendOrgData = {
          tenantID: tokenInfo.tenant,
          organizationId: getUserDetails?.data.organizationId,
        };

        dispatch(getOrganizationUserByTenantID(sendOrgData))
          .unwrap()
          .then((response: any) => {
            // Check if user is found in the API response directly
            const userData = response?.originalUserData || response || [];

            const isUserFound = userData.some((user: UserDto) => {
              const currentUserEmail = user.emailId || (user as any).email;
              return currentUserEmail && currentUserEmail.toLowerCase() === userEmail.toLowerCase();
            });

            if (isUserFound) {
              // Move the newly created user to the top of the table using fresh API data
              const target = userEmail.toLowerCase();
              const foundUser = userData.find((u: UserDto) => (u.emailId || (u as any).email || '').toLowerCase() === target);
              if (foundUser) {
                const rest = userData.filter((u: UserDto) => u !== foundUser);
                setGetAllGridData([foundUser, ...rest]);
                setRefreshKey(prev => prev + 1);
              } else {
                // Fallback to regular refresh if not found for some reason
                setOrgUserList();
              }
              stopPolling();
              return; // Exit poll loop early
            } else if (attempts >= MAX_ATTEMPTS) {
              stopPolling();
            }
          })
          .catch(() => {
            stopPolling();
          });
      };

      // Start polling
      pollingInterval.current = setInterval(poll, POLLING_INTERVAL);
    }

    return () => stopPolling();
  }, [location.search, getUserDetails?.data.organizationId, userPermissions.can_read_organisation_user, getUserDetails?.permissionSet?.can_read_organisation_user]);

 // Simple polling for user updates - triggered by sessionStorage
  useEffect(() => {
    // Prevent running if already started
    if (hasStartedPollingRef.current) {
      return;
    }
    
    // Check sessionStorage for user update info
    const userUpdateInfoStr = sessionStorage.getItem('userUpdateInfo');
    
    if (!userUpdateInfoStr) {
      return;
    }
    
    const userUpdateInfo = JSON.parse(userUpdateInfoStr);
    
    // Store in ref so it persists across re-renders
    userUpdateInfoRef.current = userUpdateInfo;
    
    // Mark that we've started polling
    hasStartedPollingRef.current = true;
    
    // Reset attempts counter
    userUpdateAttemptsRef.current = 0;
    
    // Clear sessionStorage immediately so it doesn't re-trigger on re-render
    sessionStorage.removeItem('userUpdateInfo'); 
    
    const maxAttempts = 10;
    
    const stopUserUpdatePolling = () => {
      if (userUpdatePollingRef.current) {
        clearInterval(userUpdatePollingRef.current);
        userUpdatePollingRef.current = null;
      }
      setShowUpdateBanner(false);
      hasStartedPollingRef.current = false;
      userUpdateInfoRef.current = null;
      userUpdateAttemptsRef.current = 0;
    };
    
    const poll = () => {
      // Use ref value which persists
      const currentUserUpdateInfo = userUpdateInfoRef.current;
      if (!currentUserUpdateInfo) {
        stopUserUpdatePolling();
        return;
      }
      
      // Increment attempts using ref
      userUpdateAttemptsRef.current++;
      const currentAttempt = userUpdateAttemptsRef.current;
      
      if (!userPermissions.can_read_organisation_user || !getUserDetails?.permissionSet?.can_read_organisation_user) {
        stopUserUpdatePolling();
        return;
      }
      
      /*
       * Note:
       * The polling logic now uses the global user data fetch endpoint (`getUserListBasedOnForgeCustomerId`)
       * instead of the organization-specific endpoint. This change was made to ensure that user updates
       * are detected across all organizations associated with the tenant, providing consistency and
       * supporting scenarios where users may belong to multiple organizations. Additionally, the global
       * endpoint allows for more comprehensive user tracking and improves the reliability of detecting
       * when users are moved between organizations.
       * Currently org specific endpoint for users returns only current org 
       */
      dispatch(getUserListBasedOnForgeCustomerId({ 
        id: tokenInfo.tenant, 
        silent: true 
      }))
      .unwrap()
      .then((response: any) => {
        
        // Find user in global data to compare all their current data
        const globalUsers = response?.result || response || [];
        const user = globalUsers.find((u: any) => u.userId === currentUserUpdateInfo.userId);

        if (!user) {
          stopUserUpdatePolling();
          return;
        }

        // First, check if user still belongs to the current organization we're viewing
        const currentOrgId = getUserDetails?.data.organizationId;
        const userOrgs = user.organization?.map((org: any) => org.id) || [];
        const userStillInCurrentOrg = userOrgs.includes(currentOrgId);
        
        // If user was moved away from current org, stop polling and refresh immediately
        if (!userStillInCurrentOrg) {
          stopUserUpdatePolling();
          // Silent refresh to show updated list without this user
          const sendOrgData = {
            tenantID: tokenInfo.tenant,
            organizationId: getUserDetails?.data.organizationId,
          };
          dispatch(getOrganizationUserByTenantID(sendOrgData));
          return;
        }

        // If user is still in current org, compare all expected fields with current user data
        let allChangesMatch = true;

        // Check organizations (always compare if present in update info)
        if (currentUserUpdateInfo.organization) {
          const editedOrgs = currentUserUpdateInfo.organization.map((org: any) => org.id);
          const orgsMatch = editedOrgs.every((orgId: string) => userOrgs.includes(orgId));
          allChangesMatch = allChangesMatch && orgsMatch;
        }

        // Check roles (always compare if present in update info)
        if (currentUserUpdateInfo.roles) {
          const editedRoles = currentUserUpdateInfo.roles;
          const userRoles = user.roles?.map((r: any) => r.roleId) || [];
          const rolesMatch = 
            editedRoles.length === userRoles.length &&
            editedRoles.every((roleId: string) => userRoles.includes(roleId));
          allChangesMatch = allChangesMatch && rolesMatch;
        }

        if (allChangesMatch) {
          stopUserUpdatePolling();
          // Silent refresh without showing loading indicator
          const sendOrgData = {
            tenantID: tokenInfo.tenant,
            organizationId: getUserDetails?.data.organizationId,
          };
          dispatch(getOrganizationUserByTenantID(sendOrgData));
          return;
        } else if (currentAttempt >= maxAttempts) {
          stopUserUpdatePolling();
        }
      })
      .catch(() => {
        stopUserUpdatePolling();
      });
    };
    
    // Show banner immediately
    setShowUpdateBanner(true);
    
    // Set up interval first (poll will be called by the interval)
    userUpdatePollingRef.current = setInterval(poll, POLLING_INTERVAL);
    
    // Cleanup - but DON'T clear interval if we're just remounting (React StrictMode)
    return () => {
      // Only cleanup if polling is actually done (hasStartedPollingRef will be false)
      // This prevents React StrictMode from clearing the interval on dev remounts
      if (!hasStartedPollingRef.current && userUpdatePollingRef.current) {
        clearInterval(userUpdatePollingRef.current);
        userUpdatePollingRef.current = null;
        setShowUpdateBanner(false);
      }
    };
  }, []); // Run only on mount - sessionStorage check is one-time

  const handleDeleteforOrg = () => {
    if (userPermissions.can_delete_organisation) {
      deleteOrganization(null, getUserDetails);
    } else {
      const error: IErrorProps = {
        errorCode: 403,
        errorMessage: t(localeKeyMap.noPrivilegesToDeleteOrganizations),
      };
      const errorListData: IErrorProps[] = [];
      errorListData.push(error);
      toastErrors.current = errorListData;
      setOpenToastError(true);
    }
  };

  function handleEdit(
    //event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    cellValues: any
  ) {
    // TODO: Edit

    var orgName = getOrganizationNameById(
      getUserDetails?.data?.organizationId,
      organizationOrigionaldata
    );

    if (userPermissions.can_update_organisation_user) {
      const userDetailsToEdit = {
        CustomerId: getUserTenantId,
        UserInfo: { ...cellValues?.row, navigatedOrganization: orgName },
      };

      navigate(`/organization/user/edit`, {
        state: {
          userDetailsToEdit,
        },
      });
    } else {
      const error: IErrorProps = {
        errorCode: 403,
        errorMessage: t(localeKeyMap.noPrivilegesToEditUsers),
      };
      setErrorListGlobal((prevState) => updateErrorList(error, [...prevState]));
    }
  }

  // const columns: GridColDef[] = [
  //   {
  //     field: "name",
  //     headerName: "Name",
  //     flex: 1,
  //     renderCell: (params) => (
  //       <Button>
  //         {params.row.firstName} {params.row.lastName}
  //       </Button>
  //     ),
  //   },
  //   { field: "emailId", headerName: "Email", flex: 1 },
  //   {
  //     field: "roles",
  //     headerName: "Roles",
  //     flex: 1,
  //     renderCell: (params) => {
  //       const { row } = params;
  //       const renderedData = row.roles
  //         ?.map((data: { name: string }, index: number) => data.name)
  //         .join(", ");
  //       return (
  //         <>
  //           <Tooltip
  //             title={`Roles: ${row.roles
  //               ?.map((data: { name: any }) => data.name)
  //               .join(", ")}`}
  //           >
  //             <span className="roles_text">{renderedData}</span>
  //           </Tooltip>
  //         </>
  //       );
  //     },
  //   },
  //   {
  //     field: "organization",
  //     headerName: "ORGANIZATION",
  //     sortable: true,
  //     flex: 2,
  //     renderCell: (cellValues: any) => {
  //       if (cellValues?.row?.organization?.length == 0) {
  //         return "No Organization";
  //       } else if (cellValues?.row?.organization?.length > 0) {
  //         const remainingOptions = cellValues?.row?.organization.slice(1);
  //         const remainingLabels = remainingOptions.map(
  //           (option: any) => option.name
  //         );
  //         const commaSeparatedString = remainingLabels.join(", ");
  //         // return cellValues.row.organizationId[0] + "..." + <div>test</div>;
  //         return (
  //           <Grid>
  //             <Tooltip
  //               placement="right-start"
  //               arrow
  //               title={cellValues?.row?.organization.map((el: any) => {
  //                 return (
  //                   <Tooltip
  //                     placement="right-start"
  //                     arrow
  //                     title={
  //                       <OrgHierarchyTooltip
  //                         selectedKeyLsit={[el.name]}
  //                         hierarchicalOrganizationwKey={
  //                           hierarchicalOrganizationwKey
  //                         }
  //                       />
  //                     }
  //                   >
  //                     <div style={{ color: "$button-color-font" }}>{el.name}</div>
  //                   </Tooltip>
  //                 );
  //               })}
  //             >
  //               {cellValues?.row?.organization?.length == 1 ? (
  //                 cellValues?.row?.organization[0]?.name
  //               ) : (
  //                 <div>
  //                   {cellValues?.row?.organization[0]?.name},{" "}
  //                   <span style={{ color: "$button-color-font" }}>
  //                     +{cellValues?.row?.organization?.length - 1}
  //                   </span>
  //                 </div>
  //               )}
  //             </Tooltip>
  //           </Grid>
  //         );
  //       } else {
  //       }
  //     },
  //   },
  //   {
  //     field: "Action",
  //     headerName: "Action",
  //     flex: 1,
  //     sortable: false,

  //     renderCell: (cellValues: any) => {

  //       return (
  //         <div>
  //           <Button
  //             sx={{
  //               fontSize: 14,
  //               padding: 0,
  //               justifyContent: "start",
  //               color: "$button-color-font",
  //               textTransform: "none",
  //               fontFamily: "Honeywell Sans Web",
  //             }}
  //             data-testid="editbuttonrow"
  //             onClick={(event) => {
  //               handleEdit(event, cellValues);
  //             }}
  //           >
  //             Edit
  //           </Button>
  //           <Button
  //             sx={{
  //               fontSize: 14,
  //               padding: 0,
  //               justifyContent: "start",
  //               color: "$button-color-font",
  //               textTransform: "none",
  //               fontFamily: "Honeywell Sans Web",
  //             }}
  //             onClick={(event) => {
  //               handleDeleteforUsers(event, cellValues);
  //             }}
  //             variant="text"
  //             color="primary"
  //           >
  //             Delete
  //           </Button>
  //         </div>
  //       );
  //     },
  //   },
  // ];

  function handleDeleteforUsers(
    //event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    cellValues: any
  ) {
    if (userPermissions.can_delete_user) {
      setTenantUsersToDelete({
        customerId: getUserTenantId,
        userIds: [cellValues.row.userId],
      });
      setOpenforDeleteUsers(true);
    } else {
      const error = {
        status: 403,
        data: t(localeKeyMap.noPrivilegesToDeleteUsers),
      };
      setErrorListGlobal((prevState) => updateErrorList(error, [...prevState]));
    }
  }

  const showBox = () => setHideBox(!hidebox);
  function Pagination({
    page,
    onPageChange,
    className,
  }: Pick<TablePaginationProps, "page" | "onPageChange" | "className">) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <div className="navigation-goto-pagination-wrapper">
        <div className="navigation-pagination">
          <MuiPagination
            color="primary"
            className={className}
            count={pageCount}
            page={page + 1}
            onChange={(event, newPage) => {
              onPageChange(event as any, newPage - 1);
            }}
          />
        </div>
        <div className="goto-pagination-wrapper">
          <GoToPage
            pageCount={pageCount}
            handleGoToPage={(page) => {
              setPaginationModel((prevModel) => ({
                ...prevModel,
                page: page,
              }));
            }}
          />
        </div>
      </div>
    );
  }
  function CustomPagination(props: any) {
    return <GridPagination sx={{}} ActionsComponent={Pagination} {...props} />;
  }

  const findParentNodeName = (tree: any, childKey: any) => {
    const findParent = (currentNode: any, key: any) => {
      if (currentNode.children) {
        for (const childNode of currentNode.children) {
          if (childNode?.key === key) {
            return currentNode.data?.name; // Found the parent, return its name
          } else {
            const result: any = findParent(childNode, key);
            if (result !== null) {
              return result; // Propagate the result upward if found in a child
            }
          }
        }
      }
      return null; // Key not found in this branch
    };

    // Start the search from the root of the tree
    return findParent({ children: tree }, childKey);
  };
  const childKey = getUserDetails?.key;
  const parentNodeName = findParentNodeName(treeTableOrganization, childKey);
  const handleClose = () => {
    setOpenDialog(false);
    setOpenforDeleteUsers(false);
  };
  const handleSuccesssConfirmationClose = () => {
    let keyOfOrgLastDeleted = getOrganizationKeyByOrgId(
      OrgToDelete.organizationId,
      treeTableOrganization
    );
    const getKeysToExpand = getAllParentKeys(keyOfOrgLastDeleted?.key);
    dispatch(organizationActions.setExpandedKeyforEdit(getKeysToExpand));
    setOrgToDelete(undefined);
    setSuccessDialogOpen(false);
    navigate("/organization");
  };

  const [crumbs, setCrumbs] = useState([
    {
      id: ORGANIZATION_CRUMB_ID,
      label: t(localeKeyMap.organization),
    },
    {
      id: "OrganizationName",
      label: getUserDetails?.data?.name || "",
      noAction: true,
    },
  ]);

  const handleSuccesssforDeleteUsers = () => {
    // setOpenforDeleteUsers(false);
    setSuccessDialogOpenforUsers(false);
    const sendOrgData: any = {
      tenantID: tokenInfo.tenant,
      organizationId: getUserDetails.data.organizationId,
    };
    setOpenDialog(false);
    setIsLoading(true);
    dispatch(getOrganizationUserByTenantID(sendOrgData))
      .unwrap()
      .then(() => {})
      .catch((error: any) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => setIsLoading(false));
  };
  const handleDeleteConfirmation = () => {
    setOpenDialog(false);
    setIsLoading(true);
    const orgInfo = {
      tenantId: tenantId,
      organizationId: OrgToDelete.organizationId,
    };
    dispatch(deleteOrganizationbyID(orgInfo))
      .unwrap()
      .then(() => {
        setSuccessDialogOpen(true);
      })
      .catch((error: any) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => setIsLoading(false));
  };
  const deleteOrganization = (
    event: any,
    rowData: TreeTableOrganizationData
  ) => {
    setOpenDialog(true);
    setOrgToDelete(rowData.data);
  };

  // Handle Edit confirmation
  // istanbul ignore next
  // This is passed to Dialog
  const handleEditOrg = () => {
    if (userPermissions.can_create_organisation) {
      const organisationDetailsToEdit = {
        tenantId: getUserTenantId,
        UserInfo: getUserDetails,
        organisationEditfromDetailPage: true,
      };
      dispatch(
        organizationActions.organisationToEdit(organisationDetailsToEdit)
      );
      navigate(`/organization/edit`, {
        // state: { organisationDetailsToEdit },
      });
    } else {
      const error: IErrorProps = {
        errorCode: 403,
        errorMessage: t(localeKeyMap.noPrivilegesToEditOrganizations),
      };
      const errorListData: IErrorProps[] = [];
      errorListData.push(error);
      toastErrors.current = errorListData;
      setOpenToastError(true);
    }
  };
  //CID 3263540
  let orgProps = {
    orgInfo: organizationUserPageDetailsStore,
    editOrgMenu: handleEditOrg,
    name: "",
    parentName: parentNodeName,
    deleteOrgMenu: handleDeleteforOrg,
  };

  if (getUserDetails) {
    orgProps = {
      ...orgProps,
      name: getUserDetails.data?.name,
    };

    if (
      getUserDetails.data?.user === 0 &&
      getUserDetails.children?.length === 0
    ) {
      orgProps.deleteOrgMenu = handleDeleteforOrg;
    }
  }

  const custProps: any = {
    handleEdit: handleEdit,
    handleDelete: handleDeleteforUsers,
    component: "organizationUserList",
    CustomerId: getUserTenantId,
    // CustomerDetails: location?.state,
    to: "/tenant/user/info",
    OrganizationInformation: getUserDetails,
    t: t
  };

  function onFilterChangehandler(filters: Role[]) {
    // Set filters
    setFilteringGroup(filters);
  }

  function removeFilter(item: unknown) {
    setFilteringGroup(filteringGroup.filter((role) => role !== item));
  }
  const backButtonHandler = () => {
    navigate(-1);
  };

  const handleCrumbClick = (crumb: { id: string; href?: string }) => {
    if (crumb.id === ORGANIZATION_CRUMB_ID) {
      navigate("/organization");
    }
  };

   // Cleanup selectedOrganizationData when navigating away from organization page
  useEffect(() => {
    return () => {
      // Only remove sessionStorage if navigating away from /organization path
      if (location.pathname !== LOCATION_PATHNAME) {
        sessionStorage.removeItem('selectedOrganizationData');
      }
    };
  }, [location.pathname]);
  return (
    <>
      <BreadCrumbsComponent
        crumbs={crumbs}
        backbutton={true}
        backButtonHandler={backButtonHandler}
        onCrumbClick={handleCrumbClick}
      />
      <Title title={t(localeKeyMap.organizationUsers)} className="p-t15 p-b20" />
      <OrganizationInfoComponent {...orgProps} />

      {/* <div className="p-15 bg-white border-gray border-radius-10 create_tenant"></div> */}

      {/* //////////////////////////////////////////////// */}
      <Card className="main_org_user_wrap">
        <div
          className={` d-flex align-items-center justify-items-between table-title`}
        >
          <div className="data_top_part">
            <h3 className="menu-title-1">{t(localeKeyMap.organizationUserList)}</h3>
            <h3 className="subtitle-2">
              &nbsp; | &nbsp;
              {getAllGridData?.length === 1 ? (
                <span>1 {t(localeKeyMap.user)}</span>
              ) : (
                <span>{getAllGridData?.length} {t(localeKeyMap.users)}</span>
              )}
            </h3>
          </div>
          <div className={`d-flex align-items-center spacing-g-10  p-r20`}>
            <div className="main_org_table_search">
              <span className="pi pi-search"></span>
              <Input
                id="search"
                placeholder={t(localeKeyMap.search)}
                prefix={<SearchIcon strokeWidth={2} />}
                size="regular"
                onChange={(e) => {
                  setSearchedText(e.target.value);
                }}
                value={searchedText}
              />
            </div>
            {/* // Need to remove this */}
            {/* <Button
              icon={<FilterIcon strokeWidth={2} />}
              iconPosition="left"
              label="Schedule"
              // onClick={refreshHandeller}
              size="regular"
              variant="tertiary"
            /> */}
            <TemporaryDrawerForOrgUser
              isFilterDisabled={isLoading}
              filteringGroup={filteringGroup}
              onFilteringCriteriaChange={(filters: any) =>
                onFilterChangehandler(filters)
              }
              hierarchicalOrganizationwKey={hierarchicalOrganizationwKey}
              comp="tenantUserPage"
              gridData={originalGetUserData}
            />
            <Button
              icon={<RefreshIcon strokeWidth={2} />}
              iconPosition="left"
              label={t(localeKeyMap.refresh)}
              onClick={getOrgUserList}
              size="regular"
              variant="tertiary"
              aria-label="Refresh"
            />

            <Button
              icon={<ImportIcon strokeWidth={2} />}
              iconPosition="left"
              label={t(localeKeyMap.downloadExcel)}
              onClick={() => downloadExcel()}
              size="regular"
              variant="tertiary"
              aria-label="Download Excel"
              data-testid="downloadExcel"
            />

            <Button
              variant="primary"
              onClick={createUserHandler}
              disabled={
                !(
                  userPermissions?.can_create_organisation_user &&
                  getUserDetails?.permissionSet?.can_create_organisation_user
                )
              }
            >
              {t(localeKeyMap.createNewUser)}
            </Button>
          </div>
        </div>

        {/* //chips logic */}
        {/* istanbul ignore next*/}
        <div className={`d-flex align-items-center p-10 border-div`}>
          {filteringGroup?.map(
            (item, index) =>
              index < 5 && (
                <Chip onClick={function noRefCheck() {}} className="theme-chip">
                  {item.name}
                  <ChipRemove
                    onClick={() => removeFilter(item)}
                    className="theme-chip-remove"
                    data-testid="removeFilter"
                  >
                    {t(localeKeyMap.removeChipWithContent)}
                  </ChipRemove>
                </Chip>
              )
          )}
          {/* CID 3304390 */}
          {filteringGroup && filteringGroup?.map((x) => x.name).length > 5 && (
            <>
              {" "}
              <Chip className="dot-item theme-chip">..</Chip>
              <Tooltip
                title={filteringGroup
                  .map((x) => x.name)
                  .slice(5)
                  .join(", ")}
                arrow={true}
              >
                <div>
                  <Chip className="theme-chip">
                    {`+${(
                      filteringGroup?.map((x) => x.name).length - 5
                    ).toString()}`}
                  </Chip>
                </div>
              </Tooltip>
            </>
          )}
        </div>
        {/* // end chips logic */}
        
        {/* User Creation Banner */}
        <NotificationBanner 
          isVisible={showNotificationBanner} 
          type="warning" 
          hideIcon={false}
          titleLocaleKey="userCreationInProgress"
          descriptionLocaleKey="userCreationInProgressDescription"
        />

        {/* User Update Banner */}
        <NotificationBanner 
          isVisible={showUpdateBanner} 
          type="warning" 
          hideIcon={false}
          titleLocaleKey="userUpdateInProgress"
          descriptionLocaleKey="userUpdateInProgressDescription"
        />

        {/* Data Table Here */}
        {/* istanbul ignore next*/}

        <DataGrid
          key={refreshKey}
          disableColumnMenu
          rows={getAllGridData ?? []}
          columns={gridColumns(custProps)}
          pagination
          slots={{
            pagination: CustomPagination,
          }}
          checkboxSelection
          onRowSelectionModelChange={(ids) => {
            // Set selected ids .This is used while downloading selected rows through checkboxes
            setSelectedIds(Object.values(ids.map((id) => id.toString())));
          }}
          isRowSelectable={(params: any) => {
            // logged in user should not be selectable
            const isRowSelectable = loggedInUserId !== params.row.id;
            return isRowSelectable;
          }}
          disableRowSelectionOnClick
          loading={isLoadingUsers && !showNotificationBanner && !showUpdateBanner}
          localeText={customLocaleText}
          autoHeight={true}
          paginationModel={paginationModel}
          onPaginationModelChange={(model) => setPaginationModel(model)}
          pageSizeOptions={dataGridConfig.pageSizeOptions}
          sx={dataGridConfig.sx}
        />
        {/* <div className="custom_pagination">
          <Pagination
            defaultPage={1}
            count={Math.ceil(gridRowCount / paginationModel.pageSize)}
            page={paginationModel.page}
            onChange={getPageValues}
          />
        </div> */}
      </Card>
      {/* /////////////////////////////////////////////////// */}

      {openDialog && (
        //delete dialog for Organization
        <DeleteDialog
          open={openDialog}
          title={t(localeKeyMap.deleteUser)}
          handleClose={handleClose}
          DeleteConfirmationMessage={t(localeKeyMap.deleteOrganizationConfirmation)}
          subTitle={t(localeKeyMap.pleaseConfirm)}
          handleDeleteConfirmation={handleDeleteConfirmation}
        />
      )}
      {successDialogOpen && (
        <SuccessDialog
          open={successDialogOpen}
          title={t(localeKeyMap.deleteSuccessTitle)}
          SuccessConfirmationMessage={t(localeKeyMap.deleteSuccessMessage)}
          handleClose={handleSuccesssConfirmationClose}
        />
      )}
      {successDialogOpenforUsers && (
        <SuccessDialog
          open={successDialogOpenforUsers}
          title={t(localeKeyMap.deleteSuccessTitle)}
          SuccessConfirmationMessage={t(localeKeyMap.deleteSuccessMessage)}
          handleClose={handleSuccesssforDeleteUsers}
        />
      )}

      {isLoading && <Loader />}
      {openforDeleteUsers && (
        //delete dialog for org users
        <DeleteDialog
          open={openforDeleteUsers}
          title={`Delete ${
            tenantUsersToDelete?.userIds.length == 1
              ? getUsernamebyId(
                  tenantUsersToDelete?.userIds[0],
                  getAllGridData
                )
              : ""
          }`}
          handleClose={handleClose}
          subTitle={t(localeKeyMap.pleaseConfirm)}
          DeleteConfirmationMessage={
            tenantUsersToDelete?.userIds?.length > 1
              ? t(localeKeyMap.deleteMultipleUsers, { count: tenantUsersToDelete?.userIds?.length })
              : t(localeKeyMap.deleteSingleUser)
          }
          handleDeleteConfirmation={handleDeleteConfirmationforUsers}
        />
      )}
      <ErrorHandlingComponent
        openToast={openToastError}
        onCloseToast={handleToastBarClose}
        errorList={errorListGlobal.concat(toastErrors.current)}
        openServerError={openDialogServerError}
        onCloseServerError={onDialogForServerCloseHandler}
        openNoURL={openDialogNoURLError}
        onCloseNoURL={onDialogForNOURLCloseHandler}
        openDialogforConflict={false}
        onCloseServerConflictError={function (): void {}}
      />
      {(isLoading || isLoadingUsers) && <Loader />}
    </>
  );
};

export default OrganizationUserList;